query GetInboxSidebarCounts($assignees: [ID!], $inboxUserIds: [ID!]) {
    inboxThreadCounts(assignees: $assignees, inboxUserIds: $inboxUserIds) {
        sms {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
        chat {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
            chatbotCount
        }
        messenger {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
        instagram {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
        allChannels {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
        whatsapp {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
        email {
            unassignedCount
            totalCount
            hasUnread
            userInboxCounts {
                user {
                    id
                }
                count
            }
        }
    }
}
